import axios from "axios";
import config from './config.js'
const instance = axios.create({
  baseURL: config.baseUrl,
  // headers: {
  //   "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
  // },
});

export default instance;